import { API } from '../config';
import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Badge } from './ui/badge';
import { ScrollArea } from './ui/scroll-area';
import { X, Search } from 'lucide-react';


export function SearchOverlay({ onClose }) {
  const { getAuthHeaders } = useAuth();
  const [keyword, setKeyword] = useState('');
  const [platform, setPlatform] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [sender, setSender] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  const handleSearch = async () => {
    if (!keyword.trim() && !sender.trim()) return;
    setLoading(true); setSearched(true);
    try {
      const params = new URLSearchParams();
      if (keyword) params.set('keyword', keyword);
      if (platform) params.set('platform', platform);
      if (dateFrom) params.set('date_from', new Date(dateFrom).toISOString());
      if (dateTo) params.set('date_to', new Date(dateTo).toISOString());
      if (sender) params.set('sender', sender);
      const res = await axios.get(`${API}/search/messages?${params}`, { headers: getAuthHeaders() });
      setResults(res.data);
    } catch {} finally { setLoading(false); }
  };

  const handleKeyDown = (e) => { if (e.key === 'Enter') handleSearch(); if (e.key === 'Escape') onClose(); };

  return (
    <div className="fixed inset-0 z-50 bg-background/95 backdrop-blur flex flex-col" data-testid="search-overlay">
      <div className="sticky top-0 bg-card/95 backdrop-blur border-b border-border/70 px-4 py-3">
        <div className="flex items-center gap-3 mb-3">
          <Search className="w-5 h-5 text-primary" />
          <h2 className="text-lg font-semibold font-display">Gelişmiş Arama</h2>
          <div className="flex-1" />
          <Button variant="ghost" size="icon" className="rounded-xl" onClick={onClose}><X className="w-5 h-5" /></Button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
          <Input placeholder="Anahtar kelime ara..." value={keyword} onChange={e => setKeyword(e.target.value)} onKeyDown={handleKeyDown} className="rounded-xl text-sm" autoFocus data-testid="search-keyword-input" />
          <Input placeholder="Gönderen adı..." value={sender} onChange={e => setSender(e.target.value)} onKeyDown={handleKeyDown} className="rounded-xl text-sm" />
          <select value={platform} onChange={e => setPlatform(e.target.value)} className="rounded-xl border border-border/70 bg-background px-3 py-2 text-sm">
            <option value="">Tüm Platformlar</option><option value="telegram">Telegram</option><option value="whatsapp">WhatsApp</option>
          </select>
          <div className="flex gap-1">
            <Input type="date" value={dateFrom} onChange={e => setDateFrom(e.target.value)} className="rounded-xl text-xs flex-1" />
            <Input type="date" value={dateTo} onChange={e => setDateTo(e.target.value)} className="rounded-xl text-xs flex-1" />
          </div>
        </div>
        <Button onClick={handleSearch} disabled={loading} className="mt-2 rounded-xl w-full md:w-auto" data-testid="search-submit">
          {loading ? 'Aranıyor...' : 'Mesajlarda Ara'}
        </Button>
      </div>
      <ScrollArea className="flex-1 px-4 py-3">
        {!searched ? (<div className="text-center text-muted-foreground py-12 text-sm">Aramak için bir anahtar kelime veya gönderen adı girin</div>
        ) : results.length === 0 ? (<div className="text-center text-muted-foreground py-12 text-sm">Mesaj bulunamadı</div>
        ) : (<div className="space-y-2 max-w-3xl mx-auto">
          <p className="text-xs text-muted-foreground mb-3">{results.length} sonuç bulundu</p>
          {results.map(msg => (<div key={msg.id} className="bg-card rounded-xl border border-border/70 p-3">
            <div className="flex items-center gap-2 mb-1">
              <Badge variant="outline" className="text-[10px]">{msg.platform}</Badge>
              <span className="text-xs font-medium">{msg.conversation_title}</span>
              <span className="text-xs text-muted-foreground">{msg.sender?.display_name}</span>
              <span className="text-xs text-muted-foreground ml-auto">{new Date(msg.timestamp).toLocaleString('tr-TR')}</span>
            </div>
            <p className="text-sm">{keyword ? highlightSearchText(msg.text, keyword) : msg.text}</p>
          </div>))}
        </div>)}
      </ScrollArea>
    </div>
  );
}
function highlightSearchText(text, keyword) {
  if (!keyword) return text;
  const parts = text.split(new RegExp(`(${keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi'));
  return parts.map((part, i) => part.toLowerCase() === keyword.toLowerCase() ? <mark key={i} className="bg-yellow-500/30 text-inherit rounded px-0.5">{part}</mark> : part);
}
